/**
 * Handles the setting of a sharpspring script.
 * @function
 * @param {string} siteHandle - Site handle (e.g. be-NL)
 * @param {string} sharpspringBaseUrl - Base URL for the Sharpspring script.
 * @param {string} sharpspringEndpointId - Endpoint for the Sharpspring script.
 * @param {string} formName - Name of the form that sharpspring is applied to.
 */
export function handleSetSharpspringScript(
    siteHandle,
    sharpspringBaseUrl,
    sharpspringEndpointId,
    formName,
) {
    const isNotBeLux =
        siteHandle !== 'mgMotorsBelgiumNl' &&
        siteHandle !== 'mgMotorsBelgiumFr' &&
        siteHandle !== 'mgMotorsLuxembourgFr';
    if (isNotBeLux) return;
    const shaprspringScript = document.createElement('script');
    shaprspringScript.innerHTML = `
      var __ss_noform = __ss_noform || [];
      __ss_noform.push(['baseURI', \`${sharpspringBaseUrl}\`]);
      __ss_noform.push(['form', '${formName}', \`${sharpspringEndpointId}\`]);
      __ss_noform.push(['submitType', 'manual']);
    `;
    document.body.appendChild(shaprspringScript);
}
